import * as yup from 'yup';
export const stickyNotesSchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    patientId: yup.string().required(),
    noteContent: yup.string().nullable(),
});
